<template>
  <div>
    <Card>
      <template #content>
        <CoreForm
          v-model:title="form.title"
          v-model:format-type="form.formatType"
          v-model:new-attached-pdfs="form.newAttachedPdfs"
          :attached-pdfs="[]"
          :errors="errors"
          hide-select-format-type
        />

        <div class="d-flex justify-content-center my-4">
          <BasicButton
            label="キャンセル"
            variant="secondary"
            class="me-5"
            outlined
            @click="backto"
          />
          <BasicButton label="作成" button-type="submit" @click="submit" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useRouterUtil, useFormats, useZodScheme } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { UserPageActions } from "/@/vue/components/Layouts";
import { Form as CoreForm } from "/@/vue/components/Organisms/Users/Formats";
import { FormatForm, FormatCheckScheme } from "/@/types";
import { watch } from "vue";
import Card from "primevue/card";

const { backto, goto } = useRouterUtil();

const pdfElementId = "pdf-contents";

function resetForm() {
  form.title = undefined;
  form.formatType = "bcp";
  form.data = {};
  form.newAttachedPdfs = [];
}

const { useFormAndErrors } = useZodScheme();
const { form, errors, startValidation } = useFormAndErrors<FormatForm>(
  FormatCheckScheme,
  {
    formatType: "bcp",
    newAttachedPdfs: [],
  }
);

watch(form, (f) => {
  if (f.title && f.title.length > 30) {
    form.title = f.title.slice(0, 30);
  }
});

const { createFormat } = useFormats();

startValidation.value = true;

async function submit() {
  try {
    const args = FormatCheckScheme.parse(form);

    if (await createFormat(args)) {
      alert("更新しました");
      resetForm();
      goto({ name: "UsersSystemAdminBcpIndex" });
    } else {
      alert(
        "更新に失敗しました。添付されているPDFが大きすぎます。PDFが添付されていないにも関わらずこの表示が出る場合は、お手数ですが開発会社までご連絡をお願いします。"
      );
    }
  } catch (e) {
    alert("入力に問題があります。赤枠の項目を確認して下さい。");
    console.error(e);
  }
}
</script>

<style scoped></style>
